import { DataTableHeader, DataTableHeaderCell } from "~/react/ui/data-table"
import { Checkbox } from "~/react/ui/checkbox"
import type { ColumnId, ColumnDef } from "../utils"

type TableHeaderProps = {
  columns: ColumnDef[]
  draggingColumnId: ColumnId | null
  isAllSelected: boolean
  onToggleSelectAll: () => void
  connectedCount: number
  managedCount: number
  connectedActiveCount: number
  managedActiveCount: number
  dragHandlers: {
    onDragStart: (event: React.DragEvent, id: ColumnId) => void
    onDragOver: (event: React.DragEvent, id: ColumnId) => void
    onDragEnd: () => void
  }
}

export function TableHeader({
  columns,
  draggingColumnId,
  isAllSelected,
  onToggleSelectAll,
  connectedCount,
  managedCount,
  connectedActiveCount,
  managedActiveCount,
  dragHandlers,
}: TableHeaderProps) {
  return (
    <DataTableHeader>
      <DataTableHeaderCell className="h-data-table__checkbox">
        <div className="h-data-table-cell h-data-table-cell--checkbox">
          <Checkbox
            aria-label={i18n.t("js.email_accounts_center.bulk.select_page")}
            checked={isAllSelected}
            onChange={onToggleSelectAll}
          />
        </div>
      </DataTableHeaderCell>
      {columns.map((column) => (
        <DataTableHeaderCell
          key={column.id}
          sticky={column.sticky}
          draggable={!column.sticky}
          onDragStart={column.sticky ? undefined : (event) => dragHandlers.onDragStart(event, column.id)}
          onDragOver={column.sticky ? undefined : (event) => dragHandlers.onDragOver(event, column.id)}
          onDragEnd={column.sticky ? undefined : dragHandlers.onDragEnd}
          className={draggingColumnId === column.id ? "dragging" : undefined}
          {...column.cellProps}
        >
          {column.renderHeader()}
          {column.id === "email" && (connectedCount === 0 || managedCount === 0) && (
            <span className="text-xs text-hint ml-1">
              ·{" "}
              {connectedCount > 0
                ? `${connectedActiveCount}/${connectedCount}`
                : `${managedActiveCount}/${managedCount}`}
            </span>
          )}
        </DataTableHeaderCell>
      ))}
    </DataTableHeader>
  )
}
